<template>
    <div
        class="brekz-header-main__search-wrapper d-flex align-items-center py-2 my-1"
    >
        <div class="algolia-search-wrapper">
            <input
                v-model="query"
                class="brekz-header__search bg-white py-1
            pl-2 w-100"
                type="search"
                autocomplete="off"
                :placeholder="$t('algoliaSearch.searchPlaceholder')"
                id="instantsearch_query_desktop"
                @click="closeMegaMenu"
                @input="closeMegaMenu"
            />

            <svg
                v-if="query !== ''"
                @click="removeSearch"
                class="algolia-search-exit-icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                />
            </svg>
        </div>

        <button
            @click="hitSearch"
            class="brekz-header__search-button bg-white py-1"
        >
            {{ $t("algoliaSearch.searchButton") }}
        </button>
    </div>
</template>

<script>
import { debounce } from "lodash-es";

export default {
    name: "AlgoliaSearchInput",
    props: {
        menuIsAlternativeMode: {
            required: false,
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            query: ""
        };
    },
    mounted() {
        const searchParams = new URLSearchParams(window.location.search);

        if (searchParams.has("query")) {
            this.query = searchParams.get("query");
        }
    },
    watch: {
        query: debounce((newValue) => {

            const urlClass = new URL(document.location);
            if (newValue !== "") {
                urlClass.searchParams.set("query", newValue);
            } else {
                urlClass.searchParams.delete("query");
            }
            const urlWithQuery = urlClass.toString();

            urlClass.searchParams.delete("query");

            const urlWithoutQuery = urlClass.toString();

            if (history.pushState) {
                window.history.pushState({ path: urlWithoutQuery }, "", urlWithQuery);
            }

            EventBus.$emit("search-input-hit", newValue);
        }, 500)
    },
    methods: {
        hitSearch() {
            EventBus.$emit("search-input-hit", this.query);
        },
        removeSearch() {
            this.query = "";
            EventBus.$emit("search-input-hit", "")

            window.scrollTo({
                top: 1,
                behavior: 'smooth',
            })
        },
        closeMegaMenu() {
            EventBus.$emit("close-menu")
        }
    }
};
</script>
